import React, { useEffect } from 'react';
import { Col, Row } from 'react-bootstrap';

import PageWrapper from '../components/PageWrapper';
import ScrollToTop from '../components/ScrollToTop';
import { Odom } from '../HomePage/components/Highlights';
import moreDocumentsSent from '../../assets/images/raisingTheBar/moreDocumentsSent.png';
import insurersUseMpoi from '../../assets/images/raisingTheBar/insurersUseMpoi.png';
import almost900Brokerages from '../../assets/images/raisingTheBar/almost900Brokerages.png';
import nineySevenPointSix from '../../assets/images/raisingTheBar/nineySevenPointSix.png';
// import nationwideBrokerageAdoption from '../../assets/images/raisingTheBar/nationwideBrokerageAdoption.png';
import eachYearMpoisPopularityGrows from '../../assets/images/raisingTheBar/eachYearMpoisPopularityGrows.png';
import thirtyEightThousandBrokers from '../../assets/images/raisingTheBar/thirtyEightThousandBrokers.png';
import closeToFourMillion from '../../assets/images/raisingTheBar/closeToFourMillion.png';
import time from '../../assets/images/raisingTheBar/time.png';
import paper from '../../assets/images/raisingTheBar/paper.png';
import postage from '../../assets/images/raisingTheBar/postage.png';
import printing from '../../assets/images/raisingTheBar/printing.png';
import savingArrow from '../../assets/images/raisingTheBar/savingArrow.png';
// import seventyNineSayEdocs from '../../assets/images/raisingTheBar/seventyNineSayEdocs.png';
// import saveUpTo from '../../assets/images/raisingTheBar/saveUpTo.png';
import laughing from '../../assets/images/raisingTheBar/laughing.png';
import dotCom from '../../assets/images/raisingTheBar/dotCom.png';

const RaisingTheBar = (props) => {
  const { height, width, MAX_WIDTH, isMobile } = props;

  const videoPlayerWidth = (width > MAX_WIDTH ? MAX_WIDTH : width) / 2;
  const videoPlayerHeight = videoPlayerWidth * .618;

  useEffect(() => {
    // window.scrollTo(0, 0);
  }, []);

  return (
    <PageWrapper height={height} showHeaderLogo isMobile={isMobile}>
      {/* <div className="backgroundRectangle" style={{
            position: 'absolute',
            height: 1200,
            width,
            zIndex: -1
          }} />
          <div className="backgroundArrow" style={{
        position: 'absolute',
        height: 3400,
        width,
        zIndex: -1
      }} /> */}
      <Row>
        <Col>
          <h2 style={{ marginTop: 120 }}>
            <span style={{ color: '#00546F' }}>RAISING THE BAR</span> ON RELIABLE SERVICES
          </h2>
          <p style={{ marginTop: 30 }} class="greenP">
            CSIO members have always relied on CSIO for secure, trustworthy services. From MPOI, to
            CSIOnet and CSIO.com, we’re a trusted source.
          </p>
          <p class="greenP">
            While member surveys consistently show positive feedback, that hasn’t stopped us from
            trying to take services to the next level.
          </p>
          <p class="greenP">
            We want reliable, secure services members rely on to stay ahead of the curve so that
            enhancements are always ready when they are.
          </p>
          <p class="greenP">
            Our members take their responsibility to customers seriously. We’re serious about our
            responsibility to help them meet, and exceed, their expectations. Together, we create
            solutions that help each of us, and the industry, rise to new heights.
          </p>
          <h3 style={{ marginTop: 60, textAlign: 'center' }} id="my-proof-of-insurance-mpoi" tabIndex="-1">
            MY PROOF OF INSURANCE (MPOI)
          </h3>
          <p style={{ marginTop: 30 }}>
            My Proof of Insurance began an important new chapter in 2021. While MPOI has always been about
            more than eSlips, we saw members embrace its versatility this year.
          </p>
          <p>
            MPOI is Canada’s leading solution for securely emailing customers their insurance policy documents,
            including proof of auto insurance.
          </p>
          <p>
            As the pandemic continued, more brokers and insurers than ever adopted MPOI for all types of policy
            documents. Increased adoption reflects that more members are embracing all the ways they can
            use MPOI.
          </p>

          <Row style={{ marginTop: 60 }}>
            <Col style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <div style={{
                width: 300,
                height: 300,
                borderRadius: '50%',
                backgroundColor: '#FDF9EA',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                marginBottom: 30
              }}>
                <div style={{
                  position: 'absolute',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  top: 20,
                }}>
                  <img
                    src={moreDocumentsSent}
                    width="56px"
                    height="56px"
                    alt=""
                  // style={{ marginRight: 16 }}
                  />
                </div>
                <div style={{
                  margin: 25,
                  marginTop: 32,
                  width: 260,
                  height: 260,
                  borderRadius: 130,
                  // backgroundColor: '#FDF9EA',
                  display: 'flex',
                  // alignItems: 'center',
                  // justifyContent: 'center',
                  flexDirection: 'column',
                  fontFamily: '',
                  padding: 16,
                  paddingTop: 40,
                }}>
                  <div style={{ height: 72 }}>
                    <Odom number={161} text="%" odomStyle={{
                      fontSize: 60,
                      fontFamily: 'montserrat bold',
                      fontWeight: 'bold',
                      color: '#1C1F3D',
                      marginTop: 0
                    }}
                      textStyle={{
                        fontSize: 60,
                        fontFamily: 'montserrat bold',
                        fontWeight: 'bold',
                        color: '#1C1F3D',
                        marginTop: 32
                      }}
                    />
                  </div>
                  <div style={{
                    fontSize: 22,
                    fontFamily: 'montserrat bold',
                    // fontWeight: 'bold',
                    color: '#1B526D',
                    textAlign: 'center'
                  }}>
                    MORE DOCUMENTS SENT
                    DIGITALLY THAN IN 2020
                  </div>
                </div >
              </div>
            </Col>
            <Col style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <div style={{
                width: 300,
                height: 300,
                borderRadius: '50%',
                backgroundColor: '#F0F2ED',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                marginBottom: 30
              }}>
                <div style={{
                  position: 'absolute',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  top: 20,
                }}>
                  <img
                    src={almost900Brokerages}
                    width="56px"
                    height="56px"
                    alt=""
                  // style={{ marginRight: 16 }}
                  />
                </div>
                <div style={{
                  margin: 25,
                  marginTop: 32,
                  width: 260,
                  height: 260,
                  borderRadius: 130,
                  // backgroundColor: '#FDF9EA',
                  display: 'flex',
                  // alignItems: 'center',
                  // justifyContent: 'center',
                  flexDirection: 'column',
                  fontFamily: '',
                  padding: 16,
                  paddingTop: 40,
                  textAlign: 'center'
                }}>
                  <div style={{
                    position: 'relative',
                    top: 20,
                    textAlign: 'center',
                    width: '100%',
                    fontSize: 24
                  }}>
                    ALMOST
                  </div>
                  <div style={{ height: 72 }}>
                    <Odom number={900} text="" odomStyle={{
                      fontSize: 60,
                      fontFamily: 'montserrat bold',
                      fontWeight: 'bold',
                      color: '#F1C91D',
                      marginTop: 0
                    }}
                      textStyle={{
                        fontSize: 60,
                        fontFamily: 'montserrat bold',
                        fontWeight: 'bold',
                        color: '#1C1F3D',
                        marginTop: 32
                      }}
                    />
                  </div>
                  <div style={{ fontSize: 24 }}>
                    BROKERAGES
                  </div>
                  <div style={{
                    fontSize: 26,
                    fontFamily: 'montserrat bold',
                    // fontWeight: 'bold',
                    textAlign: 'center'
                  }}>
                    NOW USE<br />MPOI
                  </div>
                </div >
              </div>
            </Col>
            <Col style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <div style={{
                width: 300,
                height: 300,
                borderRadius: '50%',
                backgroundColor: '#F0F5F6',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                marginBottom: 30
              }}>
                <div style={{
                  position: 'absolute',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  top: 20,
                }}>
                  <img
                    src={insurersUseMpoi}
                    width="32px"
                    height="56px"
                    alt=""
                  // style={{ marginRight: 16 }}
                  />
                </div>
                <div style={{
                  margin: 25,
                  marginTop: 42,
                  width: 260,
                  height: 260,
                  borderRadius: 130,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexDirection: 'column',
                  padding: 16,
                  paddingTop: 10,
                  textAlign: 'center',
                  fontSize: 16,
                  fontFamily: 'montserrat bold',
                  color: '#0C5C75'
                }}>
                  <div style={{ height: 80, paddingBottom: 20 }}>
                    <Odom number={46} text="" odomStyle={{
                      fontSize: 68,
                      fontFamily: 'montserrat bold',
                      fontWeight: 'bold',
                      color: '#0C5C75',
                      lineHeight: 1,
                      marginTop: 6
                    }}
                    />
                  </div>

                  INSURERS USE MPOI AS THEIR PREFERRED

                  <div style={{
                    fontSize: 18,
                    fontFamily: 'montserrat bold',
                    textAlign: 'center',
                    color: '#1C1F3D'
                  }}>
                    eDELIVERY PLATFORM
                  </div>
                  <div style={{
                    fontSize: 16,
                    fontFamily: 'montserrat bold',
                    textAlign: 'center',
                    color: '#1C1F3D'
                  }}>
                    (UP <span style={{ color: '#1C1F3D' }}>14%</span> OVER 2020)
                  </div>
                </div >
              </div>
            </Col>
            <Col style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <div style={{
                width: 300,
                height: 300,
                borderRadius: '50%',
                backgroundColor: '#FDF3D4',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                marginBottom: 30
              }}>
                <div style={{
                  position: 'absolute',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  top: 20,
                }}>
                  <img
                    src={nineySevenPointSix}
                    width="56px"
                    height="56px"
                    alt=""
                  // style={{ marginRight: 16 }}
                  />
                </div>
                <div style={{
                  margin: 25,
                  marginTop: 40,
                  width: 260,
                  height: 260,
                  borderRadius: 130,
                  // backgroundColor: '#FDF3D4',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexDirection: 'column',
                  padding: 16,
                  // paddingTop: 16,
                  textAlign: 'center',
                  fontSize: 16,
                  fontFamily: 'montserrat bold',
                  color: '#0C5C75'
                }}>
                  <div style={{ height: 60 }}>
                    <Odom number={97.6} text="%" format="(,ddd).dd" odomStyle={{
                      fontSize: 60,
                      fontFamily: 'montserrat bold',
                      fontWeight: 'bold',
                      color: '#45644E',
                      lineHeight: 1
                      // marginTop: 0
                    }}
                      textStyle={{
                        fontSize: 60,
                        fontFamily: 'montserrat bold',
                        fontWeight: 'bold',
                        color: '#45644E',
                        marginTop: 22
                      }}
                    />
                  </div>

                  OF SENDS WERE VIA
                  API, VERSUS MANUAL
                  <div style={{
                    fontSize: 22,
                    fontFamily: 'montserrat bold',
                    textAlign: 'center',
                    color: '#1C1F3D'
                  }}>
                    (UP FROM <br /><span style={{ color: '#1C1F3D' }}>93.3%</span> IN 2020)
                  </div>
                </div >
              </div>
            </Col>
          </Row>
          <h5 style={{ color: '#849F76', marginTop: 30 }}>
            A New Chapter for MPOI
          </h5>
          <p style={{ marginTop: 30 }}>
            The MPOI story began in 2017 with a growing demand in the industry for digital tools to simplify and
            modernize insurance document transfers.
          </p>
          <p>
            Each year, MPOI’s popularity grows. But we haven’t stopped refining and enhancing the service.
            New features in 2021 included a new API version, making document transfer faster than manually
            downloading and attaching documents to an email.
          </p>
          <img
            src={eachYearMpoisPopularityGrows}
            width='100%'
            height='auto'
            alt=""
            style={{ marginTop: 30 }}
          />
          {/* <h6 style={{ color: '#1C1F3D', textTransform: 'uppercase', marginTop: 30 }}> */}
          <h4 style={{ color: '#1C1F3D', textTransform: 'uppercase', marginTop: 45 }}>
            CHECK OUT MPOI FOR YOURSELF
          </h4>
          <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
            marginTop: 30,
            marginBottom: 30
          }}>
            <iframe width={`${videoPlayerWidth}`} height={`${videoPlayerHeight}`} src="https://www.youtube.com/embed/jrcvfOjJgxQ" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
          </div>

          <blockquote>
          “With our customer experience rapidly becoming more digital, we’re pleased to now offer the option for customers who prefer electronic documents instead of print. CSIO’s My Proof of Insurance helps us provide customers a convenient option to access their insurance documents digitally. This advancement reflects our commitment to drive innovation in the broker channel and to help our broker partners empower their customers with reliable and innovative service.”
            <span>Tatjana Lalkovic, Senior Vice President and Chief Information Officer at Economical Insurance and CSIO Board Member</span>
          </blockquote>

          <h3 style={{ marginTop: 60, textAlign: 'center' }} id="eDocs" tabIndex="-1">
            <span style={{ textTransform: 'lowercase' }}>e</span>DOCS
          </h3>
          <p style={{ marginTop: 30 }}>
            eDocs have been a key to digitizing Canada’s brokerages. eDocs put policy documents in brokers’
            hands thanks to an efficient and secure download of standardized documents directly from an
            insurer to the BMS, via CSIOnet. Brokers can easily and quickly transfer the documents right to
            the customer.
          </p>
          <Row style={{ marginTop: 60 }}>
            <Col style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <div style={{
                width: 300,
                height: 300,
                borderRadius: '50%',
                backgroundColor: '#FDF9EA',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                marginBottom: 30
              }}>
                <div style={{
                  position: 'absolute',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  top: 30,
                }}>
                  <img
                    src={thirtyEightThousandBrokers}
                    width="56px"
                    height="56px"
                    alt=""
                  // style={{ marginRight: 16 }}
                  />
                </div>
                <div style={{
                  margin: 25,
                  marginTop: 32,
                  // width: 260,
                  // height: 260,
                  borderRadius: 130,
                  // backgroundColor: '#FDF9EA',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexDirection: 'column',
                  fontFamily: '',
                  // padding: 16,
                  paddingTop: 20,
                }}>
                  <div style={{ height: 24 }}>
                    <Odom number={10} text="VENDORS" odomStyle={{
                      fontSize: 24,
                      fontFamily: 'montserrat bold',
                      fontWeight: 'bold',
                      color: '#1C1F3D',
                      marginTop: 0
                    }}
                      textStyle={{
                        fontSize: 24,
                        fontFamily: 'montserrat medium',
                        color: '#1C1F3D',
                        marginLeft: 6,
                        marginTop: 2,
                        // marginTop: 32
                      }}
                    />
                  </div>
                  <div style={{ height: 24 }}>
                    <Odom number={80} text="INSURERS" odomStyle={{
                      fontSize: 24,
                      fontFamily: 'montserrat bold',
                      fontWeight: 'bold',
                      color: '#1C1F3D',
                      marginTop: 0
                    }}
                      textStyle={{
                        fontSize: 24,
                        fontFamily: 'montserrat medium',
                        color: '#1C1F3D',
                        marginLeft: 6,
                        marginTop: 2,
                        // marginTop: 32
                      }}
                    />
                  </div>
                  <div style={{ height: 24 }}>
                    <Odom number={38000} format="(,ddd)" text="BROKERS" odomStyle={{
                      fontSize: 24,
                      fontFamily: 'montserrat bold',
                      fontWeight: 'bold',
                      color: '#1C1F3D',
                      marginTop: 0
                    }}
                      textStyle={{
                        fontSize: 24,
                        fontFamily: 'montserrat medium',
                        color: '#1C1F3D',
                        marginLeft: 6,
                        marginTop: 2,
                        // marginTop: 32
                      }}
                    />
                  </div>
                  <div style={{
                    fontSize: 24,
                    fontFamily: 'montserrat medium',
                    lineHeight: 1,
                    // fontWeight: 'bold',
                    color: '#1B526D',
                    textAlign: 'center',
                    marginTop: 12
                  }}>
                    CONNECT WITH CSIOnet <span style={{
                      fontSize: 28,
                      fontFamily: 'montserrat bold',
                      lineHeight: 1,
                      // fontWeight: 'bold',
                      color: '#1B526D',
                      textAlign: 'center'
                    }}>DAILY</span>
                  </div>

                </div >
              </div>
            </Col>
            <Col style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <div style={{
                width: 300,
                height: 300,
                borderRadius: '50%',
                backgroundColor: '#F2F6F7',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                marginBottom: 30
              }}>
                <div style={{
                  position: 'absolute',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  top: 25,
                }}>
                  <img
                    src={closeToFourMillion}
                    width="64px"
                    height="56px"
                    alt=""
                  // style={{ marginRight: 16 }}
                  />
                </div>
                <div style={{
                  margin: 25,
                  marginTop: 32,
                  width: 260,
                  height: 260,
                  borderRadius: 130,
                  // backgroundColor: '#F2F6F7',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexDirection: 'column',
                  fontFamily: '',
                  padding: 16,
                  paddingTop: 60,
                  // textAlign: 'center',
                  fontSize: 20,
                }}>
                  <div style={{
                    position: 'relative',
                    top: 10
                  }}>
                    CLOSE TO
                  </div>
                  <div style={{ height: 72 }}>
                    <Odom number={4} text="M" odomStyle={{
                      fontSize: 72,
                      fontFamily: 'montserrat bold',
                      fontWeight: 'bold',
                      color: '#0C5C75',
                      lineHeight: 1
                      // marginTop: 0
                    }}
                      textStyle={{
                        fontSize: 72,
                        fontFamily: 'montserrat bold',
                        fontWeight: 'bold',
                        color: '#0C5C75',
                        lineHeight: 1,
                        marginTop: 6
                      }}
                    />
                  </div>
                  DOCUMENTS SENT
                  <div style={{
                    fontSize: 20,
                    fontFamily: 'montserrat bold',
                    textAlign: 'center'
                  }}>
                    EACH MONTH IN<br />2021
                  </div>
                </div >
              </div>
            </Col>
          </Row>
          <Row style={{
            display: 'flex',
            alignItems: 'center'
          }}>
            <Col>
              <h6 style={{ color: '#1C1F3D' }}>
                BROKERS AND INSURERS USING<br />
                CSIOnet CAN SEND AND RECEIVE
              </h6>
              <div>
                <span style={{ color: '#849F76', fontFamily: 'montserrat bold', }}>
                  eDOCS, e.g.:
                </span>
                <br />
                <ul>
                  <li>
                    NEW BUSINESS
                  </li>
                  <li>
                    RENEWALS
                  </li>
                  <li>
                    BILLING NOTICES
                  </li>
                  <li>
                    CLAIMS DOCUMENTS
                  </li>
                </ul>
                <span style={{ color: '#849F76', fontFamily: 'montserrat bold', }}>
                  OTHER POLICY DATA
                </span>
              </div>
            </Col>
            <Col style={{
              height: '100%',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              fontFamily: 'montserrat bold',
              fontSize: 36,
            }}>
              <img
                src={savingArrow}
                width="40px"
                height="40px"
                alt=""
                style={{ marginRight: 16 }}
              /> SAVING <img
                src={savingArrow}
                width="40px"
                height="40px"
                alt=""
                style={{ marginLeft: 16 }}
              />
            </Col>
            <Col style={{
              height: '100%',
              display: 'flex',
              flexDirection: 'column',
              // justifyContent: 'center',
              // alignItems: 'center',
              fontFamily: 'montserrat bold',
              fontSize: 24,
              // paddingLeft: 24
            }}>
              <Row style={{
                flex: 1,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                marginTop: 16
              }}>
                <Col xs={6} style={{
                  alignItems: 'right',
                  display: 'flex',
                  justifyContent: 'flex-end'
                }}>
                  <img
                    src={time}
                    width="48px"
                    height="48px"
                    alt=""
                    style={{ marginRight: 16 }}
                  />
                </Col>
                <Col xs={6}>
                  TIME
                </Col>
              </Row>
              <Row style={{
                height: '25%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                marginTop: 16
              }}>
                <Col xs={6} style={{
                  alignItems: 'right',
                  display: 'flex',
                  justifyContent: 'flex-end'
                }}>
                  <img
                    src={paper}
                    width="48px"
                    height="48px"
                    alt=""
                    style={{ marginRight: 16 }}
                  />
                </Col>
                <Col xs={6}>
                  PAPER
                </Col>
              </Row>
              <Row style={{
                height: '25%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                marginTop: 16
              }}>
                <Col xs={6} style={{
                  alignItems: 'right',
                  display: 'flex',
                  justifyContent: 'flex-end'
                }}>
                  <img
                    src={postage}
                    width="48px"
                    height="36px"
                    alt=""
                    style={{ marginRight: 16 }}
                  />
                </Col>
                <Col xs={6}>
                  POSTAGE
                </Col>
              </Row>
              <Row style={{
                height: '25%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                marginTop: 16
              }}>
                <Col xs={6} style={{
                  alignItems: 'right',
                  display: 'flex',
                  justifyContent: 'flex-end'
                }}>
                  <img
                    src={printing}
                    width="48px"
                    height="48px"
                    alt=""
                    style={{ marginRight: 16 }}
                  />
                </Col>
                <Col xs={6}>
                  PRINTING
                </Col>
              </Row>
            </Col>
          </Row>
          <h5 style={{ color: '#1C1F3D', textTransform: 'uppercase', marginTop: 60 }}>
            Benefits at a glance
          </h5>
          <ul>
            <li class="keyBenefits">
              Uses CSIOnet, an existing and widely adopted platform
            </li>
            <li class="keyBenefits">
              Supports all lines of business: Personal, Commercial, Farm
            </li>
            <li class="keyBenefits">
              Works for Billing and Claims documents
            </li>
            <li class="keyBenefits">
              Reliable and effective thanks to an agreed-upon eDocs standard structure
            </li>
            <li class="keyBenefits">
              Instant, real-time transactions thanks to reduced paperflow
            </li>
          </ul>
        </Col>
      </Row>
      <h5 style={{ color: '#849F76', marginTop: 30 }}>
        The evolution of eDocs certification continues
      </h5>
      <p style={{ marginTop: 30 }}>
        Members have embraced eDocs certification since we started offering certification in 2013. In 2021,
        we completed the series of eDocs certification options by adding Billing and Claims eDocs to the
        Personal Lines (2013) and Commercial Lines (2018) Certification Programs.
      </p>
      <p>
        See <a href="https://csio.com/solutions-tools/csio-certification/certified-members">this list</a> of insurers and vendors who comply with all CSIO Standards for sending eDocs, putting documents at brokers’ fingertips.
      </p>
      {/* <h5 style={{ color: '#849F76', marginTop: 60 }}>
        eDocs Certified
      </h5>
      <p style={{ marginTop: 30 }}>
        These insurers and vendors comply with all CSIO Standards for sending eDocs, putting documents at
        brokers’ fingertips.
      </p>
      <table style={{
        fontFamily: 'montserrat medium',
        width: '100%', marginTop: 30
      }}>
        <thead>
          <tr style={{
            // border: '1px solid red',
            backgroundColor: '#00546F',
            color: 'white',
            height: 60
          }}>
            <th style={{ width: '25%' }}><span style={{ visibility: 'hidden', paddingRight: 12 }}>VENDORS</span></th>
            <th style={{ width: '25%' }}>PERSONAL LINES</th>
            <th style={{ width: '25%' }}>COMMERCIAL LINES</th>
            <th style={{ width: '25%' }}>BILLING</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td style={{
              fontFamily: 'montserrat bold', paddingTop: 30
            }}>INSURERS</td>
            <td style={{ paddingTop: 30 }}>
              Aviva Canada
            </td>
            <td style={{ paddingTop: 30 }}>
              Intact Insurance
            </td>
            <td style={{ paddingTop: 30 }}>
              The Wawanesa<br />
              Mutual Insurance<br />
              Company
            </td>
          </tr>
          <tr>
            <td></td>
            <td style={{ paddingTop: 30 }}>
              CAA Insurance
            </td>
            <td style={{ paddingTop: 30 }}>
              L’Unique General<br /> Insurance
            </td>
            <td style={{ paddingTop: 30 }}></td>
          </tr>
          <tr>
            <td></td>
            <td style={{ paddingTop: 30 }}>
              Chubb Insurance
            </td>
            <td style={{ paddingTop: 30 }}>
              Northbridge Insurance
            </td>
            <td style={{ paddingTop: 30 }}></td>
          </tr>
          <tr>
            <td></td>
            <td style={{ paddingTop: 30 }}>
              Echelon Insurance
            </td>
            <td style={{ paddingTop: 30 }}>
              Optimum General Inc.
            </td>
            <td style={{ paddingTop: 30 }}></td>
          </tr>
          <tr>
            <td></td>
            <td style={{ paddingTop: 30 }}>
              Economical Insurance
            </td>
            <td style={{ paddingTop: 30 }}>
              Saskatchewan Mutual<br />Insurance
            </td>
            <td style={{ paddingTop: 30 }}></td>
          </tr>
          <tr>
            <td></td>
            <td style={{ paddingTop: 30 }}>
              Gore Mutual<br /> Insurance
            </td>
            <td style={{ paddingTop: 30 }}>
              SGI CANADA
            </td>
            <td style={{ paddingTop: 30 }}></td>
          </tr>
          <tr>
            <td></td>
            <td style={{ paddingTop: 30 }}>
              Intact Insurance
            </td>
            <td style={{ paddingTop: 30 }}>
              Travelers Canada
            </td>
            <td style={{ paddingTop: 30 }}></td>
          </tr>
          <tr>
            <td></td>
            <td style={{ paddingTop: 30 }}>
              Northbridge Insurance
            </td>
            <td style={{ paddingTop: 30 }}>
              Unica Insurance
            </td>
            <td style={{ paddingTop: 30 }}></td>
          </tr>
          <tr>
            <td></td>
            <td style={{ paddingTop: 30 }}>
              Optimum General Inc.
            </td>
            <td style={{ paddingTop: 30 }}>
              The Wawanesa Mutual<br /> Insurance Company
            </td>
            <td style={{ paddingTop: 30 }}></td>
          </tr>
          <tr>
            <td></td>
            <td style={{ paddingTop: 30 }}>
              Optiom Inc.
            </td>
            <td style={{ paddingTop: 30 }}></td>
            <td style={{ paddingTop: 30 }}></td>
          </tr>
          <tr>
            <td></td>
            <td style={{ paddingTop: 30 }}>
              Pafco Insurance Company
            </td>
            <td style={{ paddingTop: 30 }}></td>
            <td style={{ paddingTop: 30 }}></td>
          </tr>
          <tr>
            <td></td>
            <td style={{ paddingTop: 30 }}>
              Peace Hills Insurance
            </td>
            <td style={{ paddingTop: 30 }}></td>
            <td style={{ paddingTop: 30 }}></td>
          </tr>
          <tr>
            <td></td>
            <td style={{ paddingTop: 30 }}>
              Pembridge Insurance
            </td>
            <td style={{ paddingTop: 30 }}></td>
            <td style={{ paddingTop: 30 }}></td>
          </tr>
          <tr>
            <td></td>
            <td style={{ paddingTop: 30 }}>
              Portage Mutual Insurance
            </td>
            <td style={{ paddingTop: 30 }}></td>
            <td style={{ paddingTop: 30 }}></td>
          </tr>
          <tr>
            <td></td>
            <td style={{ paddingTop: 30 }}>
              Promutuel Insurance
            </td>
            <td style={{ paddingTop: 30 }}></td>
            <td style={{ paddingTop: 30 }}></td>
          </tr>
          <tr>
            <td></td>
            <td style={{ paddingTop: 30 }}>
              RSA Canada
            </td>
            <td style={{ paddingTop: 30 }}></td>
            <td style={{ paddingTop: 30 }}></td>
          </tr>
          <tr>
            <td></td>
            <td style={{ paddingTop: 30 }}>
              Saskatchewan Mutual<br />
              Insurance
            </td>
            <td style={{ paddingTop: 30 }}></td>
            <td style={{ paddingTop: 30 }}></td>
          </tr>
          <tr>
            <td></td>
            <td style={{ paddingTop: 30 }}>
              SGI CANADA
            </td>
            <td style={{ paddingTop: 30 }}></td>
            <td style={{ paddingTop: 30 }}></td>
          </tr>
          <tr>
            <td></td>
            <td style={{ paddingTop: 30 }}>
              Trillium Mutual Insurance
            </td>
            <td style={{ paddingTop: 30 }}></td>
            <td style={{ paddingTop: 30 }}></td>
          </tr>
          <tr>
            <td></td>
            <td style={{ paddingTop: 30 }}>
              Unica Insurance
            </td>
            <td style={{ paddingTop: 30 }}></td>
            <td style={{ paddingTop: 30 }}></td>
          </tr>
          <tr>
            <td></td>
            <td style={{ paddingTop: 30 }}>
              L’Unique General<br /> Insurance
            </td>
            <td style={{ paddingTop: 30 }}></td>
            <td style={{ paddingTop: 30 }}></td>
          </tr>
          <tr>
            <td></td>
            <td style={{ paddingTop: 30 }}>
              The Wawanesa Mutual<br /> Insurance Company
            </td>
            <td style={{ paddingTop: 30 }}></td>
            <td style={{ paddingTop: 30 }}></td>
          </tr>
        </tbody>
      </table>

      <table style={{
        fontFamily: 'montserrat medium',
        width: '100%',
        marginTop: 60
      }}>
        <thead>
          <tr style={{
            // border: '1px solid red',
            backgroundColor: '#00546F',
            color: 'white',
            height: 60
          }}>
            <th style={{ width: '25%' }}><span style={{ visibility: 'hidden', paddingRight: 12 }}>VENDORS</span></th>
            <th style={{ width: '25%' }}>PERSONAL LINES</th>
            <th style={{ width: '25%' }}>COMMERCIAL LINES</th>
            <th style={{ width: '25%' }}>BILLING</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td style={{
              fontFamily: 'montserrat bold', paddingTop: 30
            }}>VENDORS</td>
            <td style={{ paddingTop: 30 }}>
              Applied Systems
            </td>
            <td style={{ paddingTop: 30 }}>
              Applied Systems
            </td>
            <td style={{ paddingTop: 30 }}></td>
          </tr>
          <tr>
            <td></td>
            <td style={{ paddingTop: 30 }}>
              Logiciels Deltek Inc.
            </td>
            <td style={{ paddingTop: 30 }}>
              Logiciels Deltek Inc.
            </td>
            <td style={{ paddingTop: 30 }}></td>
          </tr>
          <tr>
            <td></td>
            <td style={{ paddingTop: 30 }}>
              Hubio Technologies
            </td>
            <td style={{ paddingTop: 30 }}>
              Hubio Technologies
            </td>
            <td style={{ paddingTop: 30 }}></td>
          </tr>
          <tr>
            <td></td>
            <td style={{ paddingTop: 30 }}>
              Vertafore Canada
            </td>
            <td style={{ paddingTop: 30 }}>
              Vertafore Canada
            </td>
            <td style={{ paddingTop: 30 }}></td>
          </tr>
          <tr>
            <td></td>
            <td style={{ paddingTop: 30 }}>
              Willis Towers Watson
            </td>
            <td style={{ paddingTop: 30 }}>
              Willis Towers Watson
            </td>
            <td style={{ paddingTop: 30 }}></td>
          </tr>
        </tbody>
      </table> */}
      {/* <h5 style={{ color: '#1C1F3D', textTransform: 'uppercase', marginTop: 60 }}>
        THE eDOCS EXPERIENCE CONTINUES TO SATISFY
      </h5>
      <Row style={{ marginTop: 30 }}>
        <Col xs={12} lg={4} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <div style={{
            width: 300,
            height: 300,
            borderRadius: '50%',
            backgroundColor: '#FEFAEE',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            marginBottom: 30
          }}>
            <div style={{
              position: 'absolute',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              top: 20,
            }}>
              <img
                src={seventyNineSayEdocs}
                width="48px"
                height="48px"
                alt=""
              // style={{ marginRight: 16 }}
              />
            </div>
            <div style={{
              margin: 25,
              marginTop: 32,
              width: 260,
              height: 260,
              borderRadius: 130,
              // backgroundColor: '#FEFAEE',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexDirection: 'column',
              fontFamily: '',
              padding: 16,
              paddingTop: 40,
              // textAlign: 'center',
              fontSize: 16,
            }}>
              <div style={{ height: 72 }}>
                <Odom number={79} text="%" odomStyle={{
                  fontSize: 72,
                  fontFamily: 'montserrat bold',
                  fontWeight: 'bold',
                  color: '#0C5C75',
                  lineHeight: 1
                  // marginTop: 0
                }}
                  textStyle={{
                    fontSize: 72,
                    fontFamily: 'montserrat bold',
                    fontWeight: 'bold',
                    color: '#0C5C75',
                    lineHeight: 1,
                    marginTop: 6
                  }}
                />
              </div>
              <div style={{ textAlign: 'center' }}>
                SAY eDOCS ARE <span style={{
                  fontSize: 18,
                  fontFamily: 'montserrat bold',
                }}> "USEFUL" </span> OR <span style={{
                  fontSize: 18,
                  fontFamily: 'montserrat bold',
                }}> "VERY USEFUL" </span> FOR <span style={{
                  fontSize: 18,
                  fontFamily: 'montserrat bold',
                }}> PERSONAL </span> AND <span style={{
                  fontSize: 18,
                  fontFamily: 'montserrat bold',
                }}> COMMERCIAL<br />LINES </span>
              </div>
            </div >
          </div>
        </Col>
        <Col xs={12} lg={4} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <div style={{
            width: 300,
            height: 300,
            borderRadius: '50%',
            backgroundColor: '#F6F8F3',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            marginBottom: 30
          }}>
            <div style={{
              position: 'absolute',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              top: 0,
            }}> 
            <div style={{
              margin: 25,
              marginTop: 16,
              width: 260,
              height: 260,
              borderRadius: 130,
              // backgroundColor: '#F6F8F3',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexDirection: 'column',
              fontFamily: '',
              padding: 16,
              paddingTop: 16,
              // textAlign: 'center',
              fontSize: 22,
              color: '#3C5C45',
              lineHeight: 1.1
            }}>
              <div style={{ height: 72, marginBottom: 4 }}>
                <Odom number={96} text="%" odomStyle={{
                  fontSize: 72,
                  fontFamily: 'montserrat bold',
                  fontWeight: 'bold',
                  color: '#1F2443',
                  lineHeight: 1
                  // marginTop: 0
                }}
                  textStyle={{
                    fontSize: 72,
                    fontFamily: 'montserrat bold',
                    fontWeight: 'bold',
                    color: '#1F2443',
                    lineHeight: 1,
                    marginTop: 6
                  }}
                />
              </div>
              <div style={{ textAlign: 'center' }}>
                <span style={{
                  fontSize: 26,
                  fontFamily: 'montserrat bold',
                }}> "SATISFIED" </span> OR <span style={{
                  fontSize: 26,
                  fontFamily: 'montserrat bold',
                }}> "VERY SATISFIED" </span> WITH THE <span style={{
                  fontSize: 26,
                  fontFamily: 'montserrat bold',
                }}> eDOCS EXPERIENCE</span>
              </div>
            </div >
          </div>
        </Col>
        <Col xs={12} lg={4} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <div style={{
            width: 300,
            height: 300,
            borderRadius: '50%',
            backgroundColor: '#F2F6F7',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            marginBottom: 30
          }}>
            <div style={{
              position: 'absolute',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              top: 18,
            }}>
              <img
                src={saveUpTo}
                width="48px"
                height="54px"
                alt=""
              // style={{ marginRight: 16 }}
              />
            </div>
            <div style={{
              margin: 25,
              marginTop: 32,
              width: 260,
              height: 260,
              borderRadius: 130,
              // backgroundColor: '#F2F6F7',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexDirection: 'column',
              fontFamily: '',
              padding: 16,
              paddingTop: 60,
              // textAlign: 'center',
              fontSize: 22,
              color: '#00546F'
            }}>
              <div style={{ height: 72 }}>
                <Odom number={73} text="%" odomStyle={{
                  fontSize: 72,
                  fontFamily: 'montserrat bold',
                  fontWeight: 'bold',
                  color: '#F8D86C',
                  lineHeight: 1
                  // marginTop: 0
                }}
                  textStyle={{
                    fontSize: 72,
                    fontFamily: 'montserrat bold',
                    fontWeight: 'bold',
                    color: '#F8D86C',
                    lineHeight: 1,
                    marginTop: 6
                  }}
                />
              </div>
              <div style={{ textAlign: 'center' }}>
                SAVE UP TO
                <span style={{
                  fontSize: 26,
                  fontFamily: 'montserrat bold',
                }}> 1 HOUR PER DAY </span> THANKS TO<br />eDOCS
              </div>
            </div >
          </div>
        </Col>
      </Row> */}
      <h3 style={{ marginTop: 60, textAlign: 'center' }} id="CSIOnet" tabIndex="-1">
        CSIO<span style={{ textTransform: 'lowercase' }}>net</span>
      </h3>
      <Row style={{ marginTop: 30 }}>
        <Col xs={12} lg={8}>
          <p style={{ marginTop: 30 }}>
            CSIOnet is the information highway along which eDocs travel among brokers, insurers and vendors.
            We’ll be modernizing CSIOnet in 2022, taking it to new heights.
          </p>
          <p>
            Since 2016, traffic on CSIOnet has doubled. That’s thanks to the success of eDocs, expanding CSIO
            membership and the need to digitize brokerages to create virtual workplaces. The traffic will grow
            even more thanks to the introduction of Billing and Claims notifications.
          </p>
          <p>
            In 2022, we’ll expand CSIOnet’s capacity to keep every eDoc moving quickly and smoothly. And
            unlike your average platform enhancement project, we won’t keep users waiting while we do it. This
            modernization project will be behind the scenes so we don’t interrupt members’ work.
          </p>
        </Col>
        <Col lg={4} style={{
          backgroundImage: `url(${laughing})`,
          backgroundPosition: 'center',
          backgroundSize: 'cover',
        }} />
      </Row>
      <h3 style={{ marginTop: 60, textAlign: 'center' }} id="csio-dot-com" tabIndex="-1">
        CSIO.com
      </h3>
      <Row style={{ marginTop: 30 }}>
        <Col lg={4} style={{
          backgroundImage: `url(${dotCom})`,
          backgroundPosition: 'center',
          backgroundSize: 'cover',
        }} />
        <Col xs={12} lg={8}>
          <p style={{ marginTop: 30 }}>
            We took our website to the next level in 2021. We simplified the site, and modernized it to reflect our
            refreshed brand.
          </p>
          <p>
            Each of our members strives to give customers a great online experience. CSIO wanted to do the
            same for our members.
          </p>
          <p>
            Every update was created with users in mind. We kept all the features from the previous site, but
            made it easier to navigate, and added a fresh look.
          </p>
          <p>
            We’ve especially enhanced the professional development features on CSIO.com. See the full story in
            the Brokers’ Technology Champions section.
          </p>
        </Col>
      </Row>



      <ScrollToTop height={height} width={width} maxWidth={MAX_WIDTH} />
    </PageWrapper>
  )
}

export default RaisingTheBar;
